import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';
import es from './locales/es.json';

// Language detection
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('i18nextLng');
  if (savedLanguage) return savedLanguage;

  const browserLanguage = navigator.language.split('-')[0];
  const supportedLanguages = ['fr', 'en', 'ar', 'es'];
  return supportedLanguages.includes(browserLanguage) ? browserLanguage : 'fr';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar },
      es: { translation: es }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'fr',

    // Better interpolation configuration
    interpolation: {
      escapeValue: false, // React already safes from XSS
      formatSeparator: ',',
      format: function(value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'currency') {
          return new Intl.NumberFormat(lng, {
            style: 'currency',
            currency: 'MAD'
          }).format(value);
        }
        return value;
      }
    },

    // React i18next specific options
    react: {
      useSuspense: false, // Set to true if you're using React Suspense
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },

    // Debugging in development
    debug: process.env.NODE_ENV === 'development',

    // Namespace separation (optional for future organization)
    defaultNS: 'translation',

    // Key separator - FIXED: changed from '.' to false
    keySeparator: false,

    // Language detection order
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Save language preference when changed
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
  document.documentElement.setAttribute('lang', lng);

  // Set direction for RTL languages
  if (lng === 'ar') {
    document.documentElement.setAttribute('dir', 'rtl');
  } else {
    document.documentElement.setAttribute('dir', 'ltr');
  }
});

export default i18n;
